import { useMemo } from 'react';
import { useUserLevelPreference } from '@bingads-webui-campaign-react/common-hooks';
import { BudgetSuggestionTiers } from '@bingads-webui-campaign-react/budget-suggestion-v2';

export const preferenceNames = {
  WizardStep: 'PMaxLite.WizardStep',
  SelectedLanguage: 'PMaxLite.SelectedLanguage',
  SelectedCountry: 'PMaxLite.SelectedCountry',
  MarketPrefillEnabled: 'PMaxLite.MarketPrefillEnabled',
  BudgetSuggestionTier: 'PMaxLite.BudgetSuggestionTier',
  SelectedCurrency: 'PMaxLite.SelectedCurrency',
  WebsiteUrl: 'PMaxLite.WebsiteUrl',
  SmartPageUrl: 'PMaxLite.SmartPageUrl',
  SmartPageTermsAndConditions: 'PMaxLite.SmartPageTermsAndConditions',
  LanguageCountryPageTermsAndConditions: 'PMaxLite.LanguageCountryPageTermsAndConditions',
  TimezonePrefillEnabled: 'PMaxLite.TimezonePrefillEnabled',
  TempImageIdString: 'PMaxLite.TempImageIdString',
  PhoneNumberCountryCode: 'PMaxLite.PhoneNumberCountryCode',
  BusinessInfoPrefillEnabled: 'PMaxLite.BusinessInfoPrefillEnabled',
  BusinessInfoStepTAndC: 'PMaxLite.BusinessInfoStepTAndC',
  AgencyIdentificationCompleted: 'PMaxLite.AgencyIdentificationCompleted',
  MSAdsOnboardingFlowSurveyTrigger: 'PMaxLite.MSAdsOnboardingFlowSurveyTrigger',
  // Agentic onboarding
  AgenticUrls: 'PMaxLite.AgenticUrls',
  AgenticDocumentBlobNames: 'PMaxLite.AgenticDocumentBlobNames',
  AgenticUploadedImageAssetIds: 'PMaxLite.AgenticUploadedImageAssetIds',
  AgenticBusinessSnapshotDraft: 'PMaxLite.AgenticBusinessSnapshotDraft',
};

export const getPreferenceDefaults = () => ({
  [preferenceNames.WizardStep]: {},
  [preferenceNames.SelectedLanguage]: 'English',
  [preferenceNames.SelectedCountry]: 'US',
  [preferenceNames.MarketPrefillEnabled]: true,
  [preferenceNames.BudgetSuggestionTier]: BudgetSuggestionTiers.Balanced,
  [preferenceNames.SelectedCurrency]: '',
  [preferenceNames.SmartPageTermsAndConditions]: {},
  [preferenceNames.LanguageCountryPageTermsAndConditions]: false,
  [preferenceNames.TimezonePrefillEnabled]: true,
  [preferenceNames.TempImageIdString]: '',
  [preferenceNames.PhoneNumberCountryCode]: '',
  [preferenceNames.BusinessInfoPrefillEnabled]: false,
  [preferenceNames.BusinessInfoStepTAndC]: false,
  [preferenceNames.AgencyIdentificationCompleted]: false,
  [preferenceNames.MSAdsOnboardingFlowSurveyTrigger]: false,
  [preferenceNames.AgenticUrls]: [],
  [preferenceNames.AgenticDocumentBlobNames]: [],
  [preferenceNames.AgenticUploadedImageAssetIds]: [],
  [preferenceNames.AgenticBusinessSnapshotDraft]: {},
});

export function usePreference(preferenceName) {
  const preferenceDefaultValue = useMemo(() => {
    // load default from list of defaults
    const preferenceDefaults = getPreferenceDefaults();
    return preferenceDefaults[preferenceName];
  }, [preferenceName]);

  return useUserLevelPreference(preferenceName, preferenceDefaultValue);
}
